import css from 'styled-jsx/css';

export default css`
  .row-capacity-color {
    &--title {
      display: flex;
      align-items: center;
      :global(.text){
        margin-right: 5px;
      }
    }
    &--content {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      margin-top: 0.5rem;
      gap: 0.5rem;
    }
  }
  @media screen and (min-width: 768px) {
    .row-capacity-color {
      &--content {
        align-items: center;
      }
    }
  }
`;
